// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";
import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost, fetchPut } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const InsertKendaraanPage = ({}) => {
  let initialState = {
    BisnisUnitID: "",
    Tanggal: new Date(),
    PurchaseOrderID: "",
    KendaraanID: "CS001",
  };

  let initialStateModal = {
    SDTDate: new Date(),
  };

  const [karyawanList, setKaryawanList] = useState([]);
  const [activityList, setActivityList] = useState([]);

  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
  } = useForm(initialState, validations);

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);

  const ModalOpener = (detail) => {
    setShowModal(true);
  };

  const param = useLocation();
  const params = useParams();

  // Mutations
  const mutation = useMutation((formData) =>
    fetchPost("Master/UserPC", formData)
  );
  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/Kendaraan", formData)
  );
  const mutationGet = useMutation((formData) =>
    fetchGet(
      "Procurement/Kendaraan/" + formData.BisnisUnitID + "/" + formData.id
    )
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPut("Procurement/Kendaraan", formData)
  );
  const po = useMutation((formData) =>
    fetchGet("Procurement/PurchaseOrder/min/" + formData)
  );
  const detailPO = useMutation((formData) =>
    fetchGet("Procurement/PurchaseOrder/warehouse/" + formData)
  );

  // Fetch data untuk dropdown
  const fetchKaryawan = useMutation(() => fetchPost("getKaryawanMinV2", {}));

  const fetchActivity = useMutation(() => fetchGet("Master/Activity/min"));

  // Load data saat komponen mount
  useEffect(() => {
    fetchKaryawan.mutate();
    fetchActivity.mutate();
    barang.mutate();

    if (params.id) {
      mutationGet.mutate({ BisnisUnitID: param.BisnisUnitID, id: params.id });
    }
  }, []);

  // Simpan data ke state
  useEffect(() => {
    if (fetchKaryawan.data?.data) {
      console.log("Data karyawan loaded:", fetchKaryawan.data.data);
      setKaryawanList(fetchKaryawan.data.data);
    }
  }, [fetchKaryawan.data]);

  useEffect(() => {
    if (fetchActivity.data?.data) {
      console.log("Data activity loaded:", fetchActivity.data.data);
      setActivityList(fetchActivity.data.data);
    }
  }, [fetchActivity.data]);
  useEffect(() => {
    console.log("Detail state:", detail);
    detail.forEach((item, index) => {
      console.log(`Item ${index}:`, {
        Nik: item.Nik,
        Nama: item.Nama,
        ActivityID: item.ActivityID,
        ActivityNama: item.ActivityNama,
        JamAwal: item.JamAwal,
        JamAkhir: item.JamAkhir,
        JamAwalType: typeof item.JamAwal,
        JamAkhirType: typeof item.JamAkhir,
      });
    });
  }, [detail]);
  const ModalEdit = (detail, id) => {
    console.log("ModalEdit called with:", { detail, id });
    setModalID(id);

    const modalData = {
      ...initialStateModal,
      ...detail,
      Nama: detail.Nama || "",
      ActivityNama: detail.ActivityNama || "",
    };

    setModalDetail(modalData);
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    const newDetail = [...detail];
    newDetail.splice(id, 1);
    setDetail(newDetail);
  };

  const navigate = useNavigate();

  // ... existing useEffect hooks ...

  const header = [
    { name: "Nik", key: "Nik", modifiers: "text" },
    { name: "Nama", key: "Nama", modifiers: "text" },
    { name: "Activity", key: "ActivityNama", modifiers: "text" },
    { name: "Hasil Kerja", key: "HasilKerja", modifiers: "text" },
    { name: "Satuan", key: "Satuan", modifiers: "text" },
    { name: "Jam Awal", key: "JamAwal", modifiers: "timeonly" },
    { name: "Jam Akhir", key: "JamAkhir", modifiers: "timeonly" },
    { name: "KMHM Awal", key: "KMHMAwal", modifiers: "text" },
    { name: "KMHM Akhir", key: "KMHMAkhir", modifiers: "text" },
    { name: "BBM", key: "BBM", modifiers: "text" },
    { name: "Keterangan", key: "KeteranganDetail", modifiers: "text" },
    { name: "tools", key: "EditDelete", modifiers: "Edit" },
  ];

  const modalHandler = (value, names) => {
    console.log("modalHandler:", { value, names });
    const newValues = { ...modalDetail, [names]: value };
    setModalDetail(newValues);
  };

  const HandlerKaryawan = (value, names, label) => {
    console.log("HandlerKaryawan:", { value, names, label });

    let nik = value;
    let nama = "";

    // 1. Coba parse dari label jika ada
    if (label && label.includes(" - ")) {
      const parts = label.split(" - ");
      if (parts.length >= 2) {
        nama = parts[1].trim();
      }
    }

    // 2. Jika nama masih kosong, cari dari karyawanList
    if (!nama && karyawanList.length > 0) {
      const karyawan = karyawanList.find((k) => k.value === value);
      if (karyawan) {
        // Parse dari label di data karyawan
        if (karyawan.label && karyawan.label.includes(" - ")) {
          const parts = karyawan.label.split(" - ");
          nama = parts[1]?.trim() || "";
        }
      }
    }

    // 3. Fallback
    if (!nama) {
      nama = `Karyawan ${nik}`;
    }

    const newValues = {
      ...modalDetail,
      [names]: nik,
      Nama: nama,
    };

    console.log("Karyawan output:", newValues);
    setModalDetail(newValues);
  };

  const HandlerActivity = (value, names, label) => {
    console.log("HandlerActivity:", { value, names, label });

    let activityID = value;
    let activityNama = "";

    // 1. Jika ada label langsung (untuk activity label biasanya langsung nama)
    if (label) {
      activityNama = label;
    }

    // 2. Cari dari activityList jika perlu
    if (!activityNama && activityList.length > 0) {
      const activity = activityList.find((a) => a.value === value);
      if (activity) {
        activityNama = activity.label || `Activity ${value}`;
      }
    }

    // 3. Fallback
    if (!activityNama) {
      activityNama = `Activity ${activityID}`;
    }

    const newValues = {
      ...modalDetail,
      [names]: activityID,
      ActivityNama: activityNama,
    };

    console.log("Activity output:", newValues);
    setModalDetail(newValues);
  };

  const modalHandlerText = (event) => {
    const newValues = {
      ...modalDetail,
      [event.target.name]: event.target.value,
    };
    setModalDetail(newValues);
  };

  const inputBuilder = [
    {
      type: "karyawan",
      name: "Nik",
      title: "Karyawan",
      handler: HandlerKaryawan,
      size: "full",
      required: true,
      disabled: false,
      edit: false,
    },
    {
      type: "JenisPetugas",
      name: "JenisPetugas",
      title: "Jenis Petugas",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "activity",
      name: "ActivityID",
      title: "Activity",
      handler: HandlerActivity,
      size: "full",
      required: true,
      disabled: false,
      edit: false,
    },
    {
      type: "SatuanKendaraan",
      name: "Satuan",
      title: "Satuan",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "time",
      name: "JamAwal",
      title: "Jam Awal",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "time",
      name: "JamAkhir",
      title: "Jam Akhir",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "number",
      name: "KMHMAwal",
      title: "KMHM Awal",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "number",
      name: "KMHMAkhir",
      title: "KMHM Akhir",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "number",
      name: "BBM",
      title: "BBM",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text",
      name: "HasilKerja",
      title: "Hasil Kerja",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text",
      name: "KeteranganDetail",
      title: "Keterangan",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
  ];

  const Kirim = () => {
    let newValues = { ...values };

    try {
      // Format tanggal ke YYYY-MM-DD
      if (newValues["Tanggal"] instanceof Date) {
        const year = newValues["Tanggal"].getFullYear();
        const month = String(newValues["Tanggal"].getMonth() + 1).padStart(
          2,
          "0"
        );
        const day = String(newValues["Tanggal"].getDate()).padStart(2, "0");
        newValues["Tanggal"] = `${year}-${month}-${day}`;
      }
    } catch (err) {
      console.error("Error converting date:", err);
    }

    // PERBAIKAN: Format detail data dengan mapping field yang benar
    const validatedDetail = detail.map((item) => {
      console.log("Processing item for submission:", item);

      // Mapping field: KeteranganDetail -> Keterangan
      const formattedItem = {
        // Field wajib untuk backend
        JenisPetugas: item.JenisPetugas || "",
        Nik: item.Nik || "0",
        ActivityID: item.ActivityID || "",
        HasilKerja: item.HasilKerja || "0",
        Satuan: item.Satuan || "",
        JamAwal: formatTimeToHHMMSS(item.JamAwal) || "00:00:00",
        JamAkhir: formatTimeToHHMMSS(item.JamAkhir) || "00:00:00",
        KMHMAwal: item.KMHMAwal || "0",
        KMHMAkhir: item.KMHMAkhir || "0",
        BBM: item.BBM || "0",
        // PERBAIKAN UTAMA: Map KeteranganDetail ke Keterangan
        Keterangan: item.KeteranganDetail || item.Keterangan || "", // Backend mengharapkan "Keterangan"
        Nama: item.Nama || "",
      };

      // Debug log untuk memastikan mapping benar
      console.log("Original KeteranganDetail:", item.KeteranganDetail);
      console.log("Mapped to Keterangan:", formattedItem.Keterangan);

      return formattedItem;
    });

    console.log("Detail sebelum kirim (validated):", validatedDetail);
    console.log(
      "JSON Payload:",
      JSON.stringify(
        {
          ...newValues,
          Data: validatedDetail,
        },
        null,
        2
      )
    );

    newValues["Data"] = validatedDetail;

    // Tambah field yang diperlukan
    newValues["Status"] = "1";
    newValues["KendaraanID"] = values.KendaraanID || "CS001";

    if (params.id) {
      console.log("Mengirim UPDATE request...");
      mutationUpdate.mutate(newValues);
    } else {
      console.log("Mengirim INSERT request...");
      mutationAdd.mutate(newValues);
    }
  };

  // Helper function untuk format waktu
  const formatTimeToHHMMSS = (timeValue) => {
    try {
      if (!timeValue) return null;

      // Jika sudah format HH:MM:SS, return langsung
      if (
        typeof timeValue === "string" &&
        /^\d{2}:\d{2}:\d{2}$/.test(timeValue)
      ) {
        return timeValue;
      }

      // Jika format HH:MM, tambah :00
      if (typeof timeValue === "string" && /^\d{2}:\d{2}$/.test(timeValue)) {
        return `${timeValue}:00`;
      }

      // Jika Date object
      if (timeValue instanceof Date) {
        const hours = String(timeValue.getHours()).padStart(2, "0");
        const minutes = String(timeValue.getMinutes()).padStart(2, "0");
        const seconds = String(timeValue.getSeconds()).padStart(2, "0");
        return `${hours}:${minutes}:${seconds}`;
      }

      // Jika ISO string
      if (typeof timeValue === "string" && timeValue.includes("T")) {
        const date = new Date(timeValue);
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${hours}:${minutes}:${seconds}`;
      }

      return null;
    } catch (error) {
      console.error("Error formatting time:", error, timeValue);
      return null;
    }
  };

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() => navigate("/equipment/kendaraan")}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>

                  <button
                    onClick={() => Kirim()}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationAdd.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Simpan"
                    )}
                  </button>
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"BisnisUnit"}
                    value={values}
                    name={"BisnisUnitID"}
                    title={"Bisnis Unit"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                {values["BisnisUnitID"] && (
                  <>
                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"dateOnly"}
                        value={values}
                        name={"Tanggal"}
                        title={"Tanggal"}
                        onChange={customHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={false}
                      />
                    </div>
                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"GeneralServiceUnit"}
                        value={values}
                        name={"GeneralServiceUnit"}
                        title={"Kode Kenderaan"}
                        onChange={customHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={false}
                      />
                    </div>
                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"text"}
                        value={values}
                        name={"Keterangan"}
                        title={"Keterangan"}
                        onChange={changeHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={false}
                      />
                    </div>
                  </>
                )}

                <hr />
                <DynamicTableSimple
                  data={detail}
                  header={header}
                  Master={true}
                  OnClick={ModalOpener}
                  name={"Purchase Requisition"}
                  barang={barang.data}
                  edit={ModalEdit}
                  delete={ModalDelete}
                />
              </div>
            </Card>
            <Modal
              size="lg"
              active={showModal}
              toggler={() => {
                setShowModal(true);
              }}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                }}
              >
                {showModalEdit ? "Edit Data" : "Tambah Data"}
              </ModalHeader>
              <ModalBody>
                <form className="w-full " onSubmit={submitHandler}>
                  {inputBuilder.map(
                    (
                      {
                        type,
                        name,
                        title,
                        handler,
                        modifiers,
                        size,
                        required,
                        disabled,
                        edit,
                      },
                      id
                    ) => {
                      if (!edit || showModalEdit) {
                        return (
                          <HrdInputGenerator
                            key={id}
                            type={type}
                            value={modalDetail}
                            name={name}
                            title={title}
                            onChange={handler}
                            touched={touched}
                            buttonTouched={buttonTouched}
                            modifiers={modifiers}
                            size={size}
                            required={required}
                            errors={errors}
                            disabled={disabled}
                          />
                        );
                      }
                      return null;
                    }
                  )}
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    setShowModalEdit(false);
                    setModalDetail(initialStateModal);
                  }}
                  ripple="dark"
                >
                  Cancel
                </Button>

                <Button
                  color={isValid || !isValid ? "green" : "blueGray"}
                  disabled={mutation.isLoading}
                  onClick={() => {
                    console.log("Modal Detail sebelum disimpan:", modalDetail);

                    // Validasi
                    if (!modalDetail.Nik || !modalDetail.ActivityID) {
                      alert("Data Karyawan dan Activity wajib diisi!");
                      return;
                    }

                    // Format waktu sebelum disimpan
                    const formatTimeForStorage = (timeValue) => {
                      if (!timeValue) return null;

                      // Jika format HH:MM, konversi ke Date object
                      if (
                        typeof timeValue === "string" &&
                        /^\d{2}:\d{2}$/.test(timeValue)
                      ) {
                        const [hours, minutes] = timeValue.split(":");
                        const date = new Date();
                        date.setHours(parseInt(hours, 10));
                        date.setMinutes(parseInt(minutes, 10));
                        date.setSeconds(0);
                        return date;
                      }

                      // Jika sudah Date object, return langsung
                      if (timeValue instanceof Date) {
                        return timeValue;
                      }

                      return timeValue;
                    };

                    // Buat detail dengan field yang benar
                    const detailToAdd = {
                      // Field untuk form
                      Nik: modalDetail.Nik || "",
                      Nama: modalDetail.Nama || "",
                      ActivityID: modalDetail.ActivityID || "",
                      ActivityNama: modalDetail.ActivityNama || "",
                      JenisPetugas: modalDetail.JenisPetugas || "",
                      HasilKerja: modalDetail.HasilKerja || "0",
                      Satuan: modalDetail.Satuan || "",
                      JamAwal: formatTimeForStorage(modalDetail.JamAwal),
                      JamAkhir: formatTimeForStorage(modalDetail.JamAkhir),
                      KMHMAwal: modalDetail.KMHMAwal || "0",
                      KMHMAkhir: modalDetail.KMHMAkhir || "0",
                      BBM: modalDetail.BBM || "0",
                      // PERBAIKAN: Simpan sebagai KeteranganDetail (akan di-mapping ke Keterangan di Kirim())
                      KeteranganDetail: modalDetail.KeteranganDetail || "",
                    };

                    console.log(
                      "Data yang akan disimpan ke detail:",
                      detailToAdd
                    );

                    if (showModalEdit) {
                      const newValues = [...detail];
                      newValues[modalID] = detailToAdd;
                      setDetail(newValues);
                    } else {
                      const newValues = [...detail, detailToAdd];
                      setDetail(newValues);
                    }

                    setModalDetail(initialStateModal);
                    setShowModal(false);
                    setShowModalEdit(false);
                  }}
                  ripple={isValid ? "light" : ""}
                >
                  {showModalEdit ? "Ubah" : "Tambah"}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsertKendaraanPage;
